/*  ========================================================================
    # Components - Search Input
    ========================================================================  */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useLocalization from '../hooks/useLocalization';

const SearchInput = ({ formCalss, input, onSubmit, placeholder, submitTitle, resetTitle }) => {
  const [searchInput, setSearchInput] = useState(input || '');
  const [submitted, setSubmitted] = useState(false);

  const handleResetInput = () => {
    onSubmit('');
    setSearchInput('');
    setSubmitted(false);
  };

  // Icons
  const local = useLocalization();
  const iconSearch = `${local('svgSprite')}#search`;
  const iconClose = `${local('svgSprite')}#close`;

  useEffect(() => {
    setSearchInput(input);
  }, [input]);

  return (
    <form
      className={`${formCalss ? formCalss : ''} c-form c-search-input ${submitted || input ? 'c-search-input--searched' : ''
        }`}
      onSubmit={event => {
        event.preventDefault();
        event.target[0].blur();
        onSubmit(searchInput);
        setSubmitted(true);
      }}
    >
      <input
        id='search-input'
        type='search'
        placeholder={placeholder}
        value={searchInput}
        onChange={e => {
          setSearchInput(e.target.value);
        }}
      />
      <label htmlFor='search-input'>{placeholder}</label>
      {searchInput !== '' && (
        <button
          className='c-search-input__reset'
          type='reset'
          aria-label={resetTitle}
          onClick={e => {
            e.preventDefault();
            handleResetInput();
          }}
        >
          <svg viewBox='0 0 200 200'>
            <use href={iconClose}></use>
          </svg>
        </button>
      )}
      <button className='c-search-input__search' type='submit' aria-label={submitTitle}>
        <svg viewBox='0 0 200 200'>
          <use href={iconSearch}></use>
        </svg>
      </button>
    </form>
  );
};

SearchInput.propTypes = {
  formCalss: PropTypes.string,
  input: PropTypes.string,
  onSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  submitTitle: PropTypes.string,
  resetTitle: PropTypes.string
};

export default SearchInput;
